import { BrandingConfig } from './types';

/**
 * Default branding configuration (Google-style colors)
 * Used as fallback when customer branding is not available
 */
export const defaultBranding: BrandingConfig = {
  // Tenant identity defaults
  tenantName: 'mAIthZen',
  appTitle: 'mAIthZen',
  tagline: 'Learn Math the Zen Way',
  logoUrl: undefined,
  
  // Colors
  primaryColor: '#1a73e8',
  primaryColorHover: '#1557b0',
  primaryColorActive: '#174ea6',
  secondaryColor: '#e8f0fe',
  secondaryColorHover: '#d2e3fc',
  backgroundColor: '#f8f9fa',
  surfaceColor: '#ffffff',
  textColor: '#202124',
  textColorMuted: '#5f6368',
  
  // Typography & Layout
  fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
  borderRadius: '0.5rem',
};

/**
 * Generate derived colors from a base primary color
 */
export function generateDerivedColors(primaryColor: string): Partial<BrandingConfig> {
  // Simple color manipulation - darken for hover/active states
  const darken = (hex: string, percent: number): string => {
    const num = parseInt(hex.replace('#', ''), 16);
    const amt = Math.round(2.55 * percent);
    const R = Math.max(0, (num >> 16) - amt);
    const G = Math.max(0, ((num >> 8) & 0x00ff) - amt);
    const B = Math.max(0, (num & 0x0000ff) - amt);
    return `#${(0x1000000 + R * 0x10000 + G * 0x100 + B).toString(16).slice(1)}`;
  };

  // Lighten for secondary color
  const lighten = (hex: string, percent: number): string => {
    const num = parseInt(hex.replace('#', ''), 16);
    const amt = Math.round(2.55 * percent);
    const R = Math.min(255, (num >> 16) + amt);
    const G = Math.min(255, ((num >> 8) & 0x00ff) + amt);
    const B = Math.min(255, (num & 0x0000ff) + amt);
    return `#${(0x1000000 + R * 0x10000 + G * 0x100 + B).toString(16).slice(1)}`;
  };

  return {
    primaryColorHover: darken(primaryColor, 15),
    primaryColorActive: darken(primaryColor, 25),
    secondaryColor: lighten(primaryColor, 70),
    secondaryColorHover: lighten(primaryColor, 60),
  };
}
